import { BASE_URL } from "../../configuration/apiconfig";
import UserStore from "../../store/UserStore";
import axios from "axios";
import API from "../../api/api";

export default class IlifestyleService {
  key = localStorage.getItem("apiKey");

  ilifeTile = async () => {
    return await API.API.get("iLifeStyle/iLifeSyleTiles")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  statement = async (start = 0, length = 10, start_date, end_date) => {
    return await API.API.get(
      "iLifeStyle/lifeStyleStatementTable?length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        start_date +
        "&end_date=" +
        end_date
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  history = async (
    start = 0,
    length = 10,
    direction = "",
    startDate = "",
    endDate = "",
    keys = "",
    order = ""
  ) => {
    return await API.API.get(
      "iLifeStyle/get-earned-history?direction=" +
        direction +
        "&length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        "&order=" +
        keys +
        "&type=" +
        order
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  earnigs = async (
    start = 0,
    length = 10,
    direction = "",
    startDate = "",
    endDate = "",
    keys = "",
    order = ""
  ) => {
    return await API.API.get(
      "iLifeStyle/get-earned-history?direction=" +
        direction +
        "&length=" +
        length +
        "&start=" +
        start +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        "&order=" +
        order
    )
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  async statement(start = 0, length = 10) {
    return new Promise((resolve, reject) => {
      fetch(
        BASE_URL +
          "iLifeStyle/lifeStyleStatementTableExports?length=" +
          length +
          "&start=" +
          start +
          "",
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }
  //Lifestyle earnings details
  async earnigsExport(startDate = "", endDate = "", keys = "", order = "") {
    return new Promise((resolve, reject) => {
      fetch(
        BASE_URL +
          "iLifeStyle/export-get-earned-history?start_date=" +
          startDate +
          "&end_date=" +
          endDate,
        {
          method: "GET",
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      )
        .then((response) => {
          return response.json();
        })
        .then((response) => {
          resolve(response);
        })
        .catch((error) => {
          reject(error);
        });
    });
  }

  async exportData(startDate = "", endDate = "", keys = "", type = "") {
    const response = await fetch(
      BASE_URL +
        "iLifeStyle/lifeStyleStatementTableExports?type=" +
        type +
        "&start_date=" +
        startDate +
        "&end_date=" +
        endDate +
        "&" +
        keys,
      {
        method: "GET", //method
        headers: {
          //passing header
          Accept: "application/json",
          "Content-Type": "application/json",
          "api-key": this.key,
          "access-token": UserStore.key,
        },
      }
    );
    return response.json();
  }

  petronCardEnrollment = async (data) => {
    try {
      const response = await API.API.post(
        "iLifeStyle/add-petron-cardard-enroll",
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  extensionAccountDetails = async () => {
    return await API.API.get("iLifeStyle/get-primaryAccount-details")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };

  pointTransfer = async (data) => {
    try {
      const response = await API.API.post(
        "iLifeStyle/i-lifestyle-points-transfer",
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };

  productsForConversion = async () => {
    return await API.API.get("iLifeStyle/get-product-details")
      .then((res) => {
        if (res.status === 200) {
          return res.data;
        } else {
          return res;
        }
      })
      .catch((error) => console.log(error));
  };
  purchaseProductForPointConversion = async (data) => {
    try {
      const response = await API.API.post(
        "iLifeStyle/point-conersion-purchase",
        data,
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
          },
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };
  SamsungStore = async (username) => {
    try {
      const response = await API.API.post(
        "Samsung/login",
        
        {
          headers: {
            Accept: "application/json",
            "Content-Type": "application/json",
            "api-key": this.key,
            "access-token": UserStore.key,
           
          },
          username,
        }
      );

      if (response.status === 200) {
        return response.data;
      } else {
        return response;
      }
    } catch (error) {
      console.log(error);
      throw new Error("Request failed");
    }
  };
}
